<div class="shared-print-container">
    <app-print *ngIf="printData" [data]="printData" [isModal]="false"></app-print>
</div>
<div *ngIf="!printData && !errorMessage" class="d-flex justify-content-center mt-5">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div *ngIf="errorMessage" class="alert alert-danger m-3">
    {{ errorMessage }}
</div>